import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";
import FormInput from "../../../../../monitoring/src/Components/Common/FormInput";
import React from "react";

export const DateFieldEditor = props => {
	const {Value, OnUpdate, FieldDef} = props;

	const handleChange = (value) => {
		const formattedValue = value ? DateUtils.FormatDate(value, 'yyyy-MM-dd') : value;
		OnUpdate(formattedValue);
	}

	return <FormInput
		type="date"
		value={DateUtils.FormatDate(Value, 'yyyy-MM-dd')}
		onChange={handleChange}
		placeholder={FieldDef?.placeholder}
		required
	/>
};
